<template>
    <div>
        <div class="calculator-form">
            <div class="calculator-form-title">Kontaktní údaje</div>

            <div class="basicForm__row basicForm__item">
                <label for="name" class="basicForm__label">Jméno <span class="required-star">*</span></label>
                <input type="text" id="name" class="button view-bordered basicForm__input" v-model="name">
            </div>
            <error-field field="calculation.demand.information.name"/>

            <div class="basicForm__row basicForm__item">
                <label for="surname" class="basicForm__label">Příjmení <span class="required-star">*</span></label>
                <input type="text" id="surname" class="button view-bordered" v-model="surname">
            </div>
            <error-field field="calculation.demand.information.surname"/>

            <div class="basicForm__row basicForm__item">
                <label for="email" class="basicForm__label">Email <span class="required-star">*</span></label>
                <input id="email" type="email" class="button view-bordered" v-model="email">
            </div>
            <error-field field="calculation.demand.information.email"/>

            <div class="basicForm__row basicForm__item">
                <label for="phone" class="basicForm__label">Telefon <span class="required-star">*</span></label>
                <input id="phone" type="tel" class="button view-bordered" v-model="phone">
            </div>
            <error-field field="calculation.demand.information.phone"/>
        </div>

        <div class="calculator-form">
            <div class="calculator-form-title">Adreasa pro doručení materiálu</div>

            <div class="basicForm__row basicForm__item">
                <label for="address" class="basicForm__label">Ulice a č. p. <span class="required-star">*</span></label>
                <input id="address" type="text" class="button view-bordered" v-model="address">
            </div>
            <error-field field="calculation.demand.information.address"/>

            <div class="basicForm__row basicForm__item">
                <label for="city" class="basicForm__label">Město <span class="required-star">*</span></label>
                <input id="city" type="text" class="button view-bordered" v-model="city">
            </div>
            <error-field field="calculation.demand.information.city"/>

            <div class="basicForm__row basicForm__item">
                <label for="zip" class="basicForm__label">PSČ <span class="required-star">*</span></label>
                <input id="zip" type="number" class="button view-bordered postCode" v-model="zip">
            </div>
            <error-field field="calculation.demand.information.zip"/>
        </div>

        <div class="notes">
            <div class="basicForm__row basicForm__item">
                <label for="note" class="basicForm__label">Poznámka</label>
                <textarea id="note" class="button view-bordered" v-model="note"></textarea>
            </div>
        </div>
        <div class="calculator-checkbox">
            <div class="basicForm__row basicForm__item" v-if="!simplifiedForm">
                <label for="pickUpAtStore" class="checkbox">
                    <input type="checkbox" id="pickUpAtStore" class="checkbox-native" v-model="pickUpAtStore">
                    <span class="checkbox-control"></span>
                    <span class="checkbox-label">
                         <span class="text--blue">Chci si zboží vyzvednout na prodejně</span>
                    </span>
                </label>
            </div>
            <div class="basicForm__row basicForm__item" v-if="!bimId && !simplifiedForm">
                <label for="withWork" class="checkbox">
                    <input type="checkbox" id="withWork" class="checkbox-native" v-model="withWork">
                    <span class="checkbox-control"></span>
                    <span class="checkbox-label">
                       <span class="text--blue">Poptat včetně práce prostřednictvím portálu NejŘemeslníci.cz</span>
                    </span>
                </label>
            </div>
            <div class="basicForm__row basicForm__item">
                <label for="mktApproval" class="checkbox">
                    <input type="checkbox" id="mktApproval" class="checkbox-native" v-model="mktApproval">
                    <span class="checkbox-control"></span>
                    <span class="checkbox-label">
                        <span class="text--blue">Souhlasím se zasíláním aktuálních informací o produktech a dalších sdělení.</span>
                    </span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapFields} from 'vuex-map-fields';
    import {mapGetters, mapActions} from 'vuex';
    import ErrorField from '../../error/ErrorField';
    import {isEmail, isPhone} from '../../../helpers/validation';

    export default {
        name: 'CalculationDemandInformationForm',
        components: {
            ErrorField
        },
        computed: {
            ...mapFields('calculation', [
                'demandInformation.name',
                'demandInformation.surname',
                'demandInformation.email',
                'demandInformation.phone',
                'demandInformation.address',
                'demandInformation.city',
                'demandInformation.zip',
                'demandInformation.note',
                'demandInformation.pickUpAtStore',
                'demandInformation.withWork',
                'demandInformation.mktApproval'
            ]),
            ...mapGetters('error', ['errors']),
            ...mapGetters('calculation', ['contactId', 'demandInformation', 'bimId']),
        },
        mounted() {
            if (null === this.contactId) {
                //this.$router.push({name: 'calculator.constructionSelect'});
            }
        },
        props: {
            simplifiedForm: {
                type: Boolean,
                default: false,
            }
        },
        methods: {
            ...mapActions('error', ['setError']),
            validate() {
                let errors = [];
                const {name, surname, email, phone, address, city, zip} = this.demandInformation;

                if (null === name || name.length === 0) {
                    this.setError({msg: 'Zadejte vaše jméno', key: 'calculation.demand.information.name'});
                }
                if (null === surname || surname.length === 0) {
                    this.setError({msg: 'Zadejte vaše přijmení', key: 'calculation.demand.information.surname'});
                }
                if (null === email || email.length === 0) {
                    this.setError({msg: 'Zadejte váš e-mail', key: 'calculation.demand.information.email'});
                } else if (!isEmail(email)) {
                    this.setError({msg: 'E-mail není ve správném tvaru', key: 'calculation.demand.information.email'});
                }
                if (null === phone || phone.length === 0) {
                    this.setError({msg: 'Zadejte váš telefon', key: 'calculation.demand.information.phone'});
                } else if (!isPhone(phone)) {
                    this.setError({msg: 'Telefon není ve správném tvaru', key: 'calculation.demand.information.phone'});
                }
                if (!this.simplifiedForm){
                    if (null === address || address.length === 0) {
                        this.setError({msg: 'Zadejte vaši adresu', key: 'calculation.demand.information.address'});
                    }
                    if (null === city || city.length === 0) {
                        this.setError({msg: 'Zadejte vaše město', key: 'calculation.demand.information.city'});
                    }
                    if (null === zip || zip.length === 0) {
                        this.setError({msg: 'Zadejte vaše PSČ', key: 'calculation.demand.information.zip'});
                        errors.push({msg: 'Zadejte vaše PSČ', field: 'zip', index: 1});
                    } else if (zip.length !== 5) {
                        this.setError({msg: 'PSČ musí být pouze 5 číslic', key: 'calculation.demand.information.zip'});
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/demand/DemandInformationForm.vue